import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "comment p-12 d-flex align-items-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_comment_box = _resolveComponent("new-comment-box")!
  const _component_single_comment = _resolveComponent("single-comment")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    errormsg: "Beim Laden der Kommentare ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder wenden Sie sich an den Seiten Administrator"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_comment_box, {
        threadId: _ctx.threadId,
        onNewComment: _ctx.reloadComments
      }, null, 8, ["threadId", "onNewComment"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: comment.id
        }, [
          (_ctx.isNotDeletedOrHasAnswers(comment))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.renderSingleCommentsOnLikesUpdate)
                  ? (_openBlock(), _createBlock(_component_single_comment, {
                      key: 0,
                      comment: comment,
                      threadId: _ctx.threadId,
                      forceShowDeleteCommentButtons: _ctx.forceShowDeleteCommentButtons,
                      onNewCommentReply: _ctx.reloadComments,
                      onCommentDeleted: _ctx.reloadComments,
                      onLikesUpdated: _ctx.rerenderSingleCommentsOnLikesUpdate
                    }, null, 8, ["comment", "threadId", "forceShowDeleteCommentButtons", "onNewCommentReply", "onCommentDeleted", "onLikesUpdated"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["state"]))
}